<template>
	<ModalComponent
		ref="modalRef"
		:isHeader="false"
		:isFooter="false"
		:is-background-transparent="true"
	>
		<div class="detail-order bg-grey-5 p-4">
			<div v-if="getDetailOrder_Status == 'error'">
				<div class="row">
					<div class="col-12 text-center">
						<h2>
							Data cannot be displayed at the moment. Please try again in a few
							minutes.
						</h2>
					</div>
					<div class="col-12 text-center">
						<button
							type="button"
							class="w-full btn c-btn-theme"
							@click="closeDetailOrder()"
						>
							Close
						</button>
					</div>
				</div>
			</div>

			<div v-else-if="getDetailOrder_Status == 'success'">
				<!-- <a title="Close" class="close">X</a> -->
				<!-- <div class="row">
					<div class="col-12 mt-3 text-center" style="color: gold;">
						<big>{{ name }}</big>
					</div>
				</div> -->

				<div
					class="flex justify-between items-center bg-grey-6 border border-solid border-grey-7 rounded text-white p-4 mb-4"
				>
					<div class="text-white text-1.7xl font-semibold">Detail Order</div>
					<div
						class="flex justify-between items-center gap-4 text-sm text-right"
					>
						<div>
							<div>
								{{
									$store.getters.getContractConfigs(detailOrder.contractId)
										.codeName
								}}
								<span class="">
									{{
										$store.getters.getContractConfigs(detailOrder.contractId)
											.contractType == "kau"
											? "KAU"
											: " "
									}}
								</span>
							</div>
							<div class="">
								{{
									$store.getters.getContractConfigs(detailOrder.contractId).name
								}}
							</div>
						</div>

						<div>
							<img
								class=""
								:src="`${publicPath}assets/icon/gold.png`"
								alt=""
								width="20"
							/>
						</div>
					</div>
					<!-- <h4 class="modal-title" id="exampleModalLabel" style="color: white">Trade Ticket</h4> -->
				</div>

				<div class="rounded text-white text-xs bg-grey-6 p-4 mb-4">
					<!-- EDIT ORDER -->
					<div class="row color-white-c" :style="{ display: displayFormEdit }">
						<div class="container rounded text-left value-field mb-0 pb-0">
							<div class="col-12 mb-3">
								<div class="mb-1.5">
									<span class="text-left">Account</span>
									<div class="text-right float-right text-white">
										{{ detailOrder.account }}
									</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left">Direction</span>
									<div
										class="text-right float-right text-uppercase font-weight-bold"
										:style="{
											color: detailOrder.direction == 'sell' ? 'red' : 'green',
										}"
									>
										{{ detailOrder.direction }}
									</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left">Valid Until</span>
									<div class="text-right float-right text-white">
										{{ detailOrder.validUntil }}
									</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left">Original Quantity</span>
									<div class="text-right float-right text-white number-font">
										{{ detailOrder.quantity }}
									</div>
								</div>
								<div class="mb-1.5">
									<span class="text-left">Original Price Per Gram</span>
									<div class="text-right float-right text-white number-font">
										{{ currencySymbol }}
										{{ pricePerGramShown }}
									</div>
								</div>
								<div class="mb-1.5">
									<span class="text-left">Original Contract Price</span>
									<div class="text-right float-right text-white number-font">
										{{ currencySymbol }}
										{{ contractPriceShown }}
									</div>
								</div>
							</div>

							<!-- <hr style="background-color: gray;"> -->

							<hr class="border border-transparent border-grey-8 mt-0 mb-3" />

							<div class="container rounded text-left">
								<div v-if="detailOrder.validity == 'GTD'" class="mb-1.5">
									<span class="text-left">Expire Date</span>
									<input
										type="datetime-local"
										name=""
										class="float-right rounded c-input c-date-picker"
										v-model="limitOrderDate"
										:min="minExpiryDateInInput"
										onkeydown="return false"
									/>
								</div>

								<div class="mb-1.5" style="line-height: 26px">
									<span class="text-left">Quantity</span>
									<div class="float-right c-input-field">
										<button
											class="button button-counter decrease"
											@click="decreaseQuantityIntEdit()"
										>
											-
										</button>
										<input
											ref="quantityMarket"
											class="c-input number-font text-white c-hide-spinner"
											type="number"
											name=""
											v-model.number="quantityIntEditInInput"
										/>
										<button
											class="button-counter increase"
											@click="increaseQuantityIntEdit()"
										>
											+
										</button>
									</div>
								</div>

								<div
									v-if="
										($store.state.contractConfigs[contractId_prop] || {})
											.hasQuantityDecimal
									"
									class="mb-1.5"
									style="line-height: 26px"
								>
									<span class="text-left" style="color: transparent">-</span>
									<div class="float-right c-input-field">
										<button
											class="button button-counter decrease"
											@click="decreaseQuantityDecimalEdit()"
										>
											-
										</button>
										<input
											ref="quantityMarket"
											class="c-input number-font text-white c-hide-spinner"
											type="text"
											name=""
											v-model.number="quantityDecimalEditInInput"
										/>
										<button
											class="button-counter increase"
											@click="increaseQuantityDecimalEdit()"
										>
											+
										</button>
									</div>
								</div>

								<div
									v-if="
										($store.state.contractConfigs[contractId_prop] || {})
											.hasQuantityDecimal
									"
									class="mb-1.5"
								>
									<span class="text-left">Total Quantity</span>
									<div class="text-right float-right text-white">
										{{ quantityEdit }}
									</div>
								</div>

								<div class="mb-1.5" style="line-height: 26px">
									<span class="text-left">Price Gram</span>
									<div class="float-right c-input-field">
										<button
											class="button button-counter decrease"
											@click="decreasePricePerGramEdit()"
										>
											-
										</button>
										<input
											class="c-input number-font text-white c-hide-spinner"
											type="text"
											name=""
											v-model.number="pricePerGramEditInInput"
										/>
										<button
											class="button-counter increase"
											@click="increasePricePerGramEdit()"
										>
											+
										</button>
									</div>
								</div>

								<div class="mb-3">
									<span class="text-left">Contract Price</span>
									<div class="text-right float-right text-white number-font">
										{{ currencySymbol }} {{ contractPriceEditShown }}
									</div>
								</div>

								<hr
									class="border border-transparent border-grey-8 mt-0 mb-3 mx--4"
								/>

								<div class="font-medium mb-1.5">
									<span class="mr-1">Rincian Order</span>
									<TooltipRincianOrder :direction="detailOrder.direction" />
								</div>

								<div class="mb-1.5">
									<span class="text-left">Contract Value</span>
									<div class="text-right float-right text-white">
										{{ currencySymbol }} {{ contractValueEditShown }}
									</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left">Fee</span>
									<div class="text-right float-right text-white number-font">
										{{ minusSignEditOrder }} {{ currencySymbol }}
										{{ feeEditShown }}
									</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left">Tax</span>
									<div class="text-right float-right text-white number-font">
										{{ minusSignEditOrder }} {{ currencySymbol }}
										{{ taxEditShown }}
									</div>
								</div>

								<div
									class="mb-3"
									:class="`${
										direction == 'sell' ? '' : `text-sm font-semibold text-gold`
									}`"
								>
									<span class="text-left">
										{{
											detailOrder.direction == "sell"
												? "Total Sell Order"
												: "Total Buy Order"
										}}
									</span>

									<div class="text-right float-right number-font">
										{{ currencySymbol }} {{ totalTypeAEditShown }}
									</div>
								</div>

								<hr class="border border-transparent border-grey-8 mt-0 mb-3" />

								<div v-if="direction == 'sell'" class="mb-1.5">
									<span class="text-right">Storage Fee</span>
									<div class="text-right float-right text-white number-font">
										{{ currencySymbol }} {{ storageFeeShown }}
									</div>
								</div>

								<div v-if="direction == 'buy'" class="mb-1.5">
									<span class="text-right">FX Buffer</span>
									<div class="text-right float-right text-white number-font">
										Rp {{ fxBufferEditShown }}
									</div>
								</div>

								<div class="font-semibold">
									<span class="text-left">
										{{
											detailOrder.direction == "buy"
												? "Total Est. Maximum Payment"
												: "Total Penjualan"
										}}
										<TooltipEstimateMaximumPayment v-if="direction == 'buy'" />
									</span>

									<div
										v-if="currency == 'idr'"
										class="text-right float-right number-font"
									>
										Rp {{ totalIdrLimitEditShown }}
									</div>

									<div v-else class="text-right float-right number-font">
										$ {{ totalUsdLimitEditShown }}
									</div>
								</div>

								<div v-if="direction == 'sell'" class="mt-1.5">
									<span class="text-left position-relative">
										Estimasi Profit
									</span>
									<div class="text-right float-right text-white number-font">
										{{ estimasiProfitEditShown }}
									</div>
								</div>

								<Cashback
									v-if="isEventRogActive && direction == 'buy'"
									:contractValue="
										currency == 'idr'
											? contractValueEditIdr
											: contractValueEditUsd
									"
								/>

								<!-- disclaimer for SELL -->
								<div v-if="direction == 'sell'" class="mt-26-c">
									<div class="flex justify-start items-start text-white">
										<input
											type="checkbox"
											class="cursor-hover-pointer h-min mr-2"
											v-model="disclaimerCheck"
										/>
										<div class="text-xs ml-1">
											Saya memahami dan menyetujui prosedur serta ketentuan
											proses penyepadanan, penyelesaian & pencairan dana
											transaksi jual sistem pasar Bursa Komoditi
											<br />
											<span
												class="text-theme cursor-pointer"
												@click="showDisclaimer()"
												>Learn More</span
											>
										</div>
									</div>
								</div>
							</div>

							<div
								v-if="priceOzt15PercentAway"
								:class="`row alert alert-danger ${
									$store.getters.getContractConfigs(contractId_prop)
										.contractType != 'kau'
										? 'bg-gold'
										: ''
								} mt-4 mb-0 mx-4 px-2 py-2`"
							>
								<div class="col-auto" style="font-size: 2.2em">&#9888;</div>
								<div class="col text-center pl-2">
									The price of this order is
									{{ Decimal.mul(minMaxLimitPrice, 100).toNumber() }}% away from
									current market price.
								</div>
							</div>
						</div>
					</div>

					<!-- OPEN -->
					<div class="row" :style="{ display: displayFormOriginalOpen }">
						<div class="col-12">
							<div class="container rounded text-left value-field">
								<div class="mb-1.5">
									<span class="text-left text color-white-c">Order ID</span>
									<div class="text-right float-right text-white">
										{{ orderId }}
									</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left text color-white-c">Status</span>
									<div
										class="text-right float-right text-white text-capitalize"
									>
										{{ detailOrder.status }}
									</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left text color-white-c">Direction</span>
									<div
										:class="`${
											detailOrder.direction == 'buy' ? 'text-green' : 'text-red'
										} text-right float-right text-white fw-700 text-uppercase`"
									>
										{{ detailOrder.direction }}
									</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left text color-white-c">Order Type</span>
									<div
										class="text-right float-right text-white text-capitalize"
									>
										{{ detailOrder.type }}
									</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left text color-white-c">Valid Until</span>
									<div
										class="text-right float-right text-white text-capitalize"
									>
										{{ detailOrder.validUntil }}
									</div>
								</div>

								<div class="mb-4">
									<span class="text-left text color-white-c">Hub</span>
									<div class="text-right float-right text-white">JAK</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left text color-white-c">Quantity</span>
									<div class="text-right float-right text-white">
										{{ detailOrder.quantity }}
									</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left text color-white-c"
										>Remain / Total Gram</span
									>
									<div class="text-right float-right text-white">
										{{ detailOrder.remainingGram }}
									</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left text color-white-c"
										>Price Per Gram</span
									>
									<div class="text-right float-right text-white">
										{{ currencySymbol }} {{ pricePerGramShown }}
									</div>
								</div>

								<div class="mb-4">
									<span class="text-left text color-white-c"
										>Contract Price</span
									>
									<div class="text-right float-right text-white">
										{{ currencySymbol }} {{ contractPriceShown }}
									</div>
								</div>

								<div class="font-medium mb-1.5">
									<span class="mr-1">Rincian Order</span>
									<TooltipRincianOrder :direction="detailOrder.direction" />
								</div>

								<div class="mb-1.5">
									<span class="text-left text color-white-c"
										>Contract Value</span
									>
									<div class="text-right float-right text-white">
										{{ currencySymbol }}
										{{ contractValueShown }}
									</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left text color-white-c">Fee</span>
									<div class="text-right float-right text-white">
										{{ minusSignDetailOrder }} {{ currencySymbol }}
										{{ feeShown }}
									</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left text color-white-c">Tax</span>
									<div class="text-right float-right text-white">
										{{ minusSignDetailOrder }} {{ currencySymbol }}
										{{ taxShown }}
									</div>
								</div>

								<div
									class="mb-4"
									:class="`${
										direction == 'sell' ? '' : `text-sm font-semibold text-gold`
									}`"
								>
									<span class="text-left">{{
										detailOrder.direction == "buy"
											? "Total Buy Order"
											: "Total Sell Order"
									}}</span>
									<div class="text-right float-right">
										{{ currencySymbol }} {{ totalTypeAShown }}
									</div>
								</div>

								<div v-if="direction == 'buy'" class="mt-1.5">
									<span class="text-left text color-white-c">FX Buffer</span>
									<div class="text-right float-right text-white">
										Rp {{ fxBufferShown }}
									</div>
								</div>

								<div class="mb-1.5 mt-1.5">
									<span class="text-left text color-white-c">
										{{
											detailOrder.direction == "buy"
												? "Total Est. Maximum Payment"
												: "Total Penjualan"
										}}
										<TooltipEstimateMaximumPayment v-if="direction == 'buy'" />
									</span>

									<div
										v-if="currency == 'idr'"
										class="text-right float-right text-white"
									>
										Rp {{ totalIdrLimitShown }}
									</div>
									<div v-else class="text-right float-right text-white">
										$ {{ totalUsdLimitShown }}
									</div>

									<div
										v-if="currency == 'usd'"
										class="text-right color-white-c mt-1"
									>
										Rp {{ totalIdrLimitShown }}
									</div>
									<div v-else class="text-right color-white-c mt-1">
										$ {{ totalUsdLimitShown }}
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- FILLED -->
					<div class="row" :style="{ display: displayFormOriginalFilled }">
						<div class="col-12">
							<div class="container rounded text-left value-field">
								<div class="mb-1.5">
									<span class="text-left text color-white-c"
										>Transaction ID</span
									>
									<div class="text-right float-right text-white">
										{{ detailOrder.transactionId }}
									</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left text color-white-c">Order ID</span>
									<div class="text-right float-right text-white">
										{{ orderId }}
									</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left text color-white-c">Status</span>
									<div
										class="text-right float-right text-white text-capitalize"
									>
										{{ detailOrder.statusShown }}
									</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left text color-white-c">Direction</span>
									<div
										:class="`${
											detailOrder.direction == 'buy'
												? 'color-green-c'
												: 'color-red-c'
										} text-right float-right text-white fw-700 text-uppercase`"
									>
										{{ detailOrder.direction }}
									</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left text color-white-c">Order Type</span>
									<div
										class="text-right float-right text-white text-capitalize"
									>
										{{ detailOrder.type }}
									</div>
								</div>

								<div class="mb-4">
									<span class="text-left text color-white-c">Hub</span>
									<div class="text-right float-right text-white">JAK</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left text color-white-c">Quantity</span>
									<div class="text-right float-right text-white">
										{{ detailOrder.quantity }}
									</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left text color-white-c">Total Gram</span>
									<div class="text-right float-right text-white">
										{{ detailOrder.totalGram }}
									</div>
								</div>

								<div class="mb-4">
									<span class="text-left text color-white-c"
										>Price Per Gram</span
									>
									<div class="text-right float-right text-white">
										{{ currencySymbol }}
										{{ pricePerGramShown }}
									</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left text color-white-c"
										>Metal Value of Trade</span
									>
									<div class="text-right float-right text-white">
										{{ currencySymbol }}
										{{ metalValueOfTradeShown }}
									</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left text color-white-c">Fee</span>
									<div class="text-right float-right text-white">
										{{ minusSignDetailOrder }} {{ currencySymbol }}
										{{ feeShown }}
									</div>
								</div>

								<div class="">
									<span class="text-left text color-white-c">Tax</span>
									<div class="text-right float-right text-white">
										{{ minusSignDetailOrder }} {{ currencySymbol }}
										{{ taxShown }}
									</div>
								</div>

								<div v-if="direction == 'buy'" class="mt-1.5">
									<span class="text-left text color-white-c"
										>FX Buffer / 5%</span
									>
									<div class="text-right float-right text-white">
										Rp {{ fxBufferShown }}
									</div>
								</div>

								<div class="mt-4 mb-1.5 fw-700">
									<span class="text-left text color-white-c"
										>Settlement Amount</span
									>

									<div
										v-if="currency == 'idr'"
										class="text-right float-right text-white"
									>
										Rp {{ settlementAmountIdrShown }}
									</div>
									<div v-else class="text-right float-right text-white">
										$ {{ settlementAmountUsdShown }}
									</div>

									<div
										v-if="currency == 'usd'"
										class="text-right color-white-c mt-1"
									>
										Rp {{ settlementAmountIdrShown }}
									</div>
									<div v-else class="text-right color-white-c mt-1">
										$ {{ settlementAmountUsdShown }}
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- KILLED -->
					<div class="row" :style="{ display: displayFormOriginalKilled }">
						<div class="col-12">
							<div class="container rounded text-left value-field">
								<div class="mb-1.5">
									<span class="text-left text color-white-c">Order ID</span>
									<div class="text-right float-right text-white">
										{{ orderId }}
									</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left text color-white-c">Status</span>
									<div
										class="text-right float-right text-white text-capitalize"
									>
										{{ status }}
									</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left text color-white-c">Direction</span>
									<div
										:class="`${
											detailOrder.direction == 'buy'
												? 'color-green-c'
												: 'color-red-c'
										} text-right float-right text-white fw-700 text-uppercase`"
									>
										{{ detailOrder.direction }}
									</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left text color-white-c">Order Type</span>
									<div
										class="text-right float-right text-white text-capitalize"
									>
										{{ detailOrder.type }}
									</div>
								</div>

								<div class="mb-4">
									<span class="text-left text color-white-c">Hub</span>
									<div class="text-right float-right text-white">JAK</div>
								</div>

								<div class="mb-1.5">
									<span class="text-left text color-white-c">Quantity</span>
									<div class="text-right float-right text-white">
										{{ detailOrder.quantity }}
									</div>
								</div>

								<div class="mb-4">
									<span class="text-left text color-white-c">Total Gram</span>
									<div class="text-right float-right text-white">
										{{ detailOrder.totalGram }}
									</div>
								</div>

								<div class="mb-1.5 fw-700">
									<span class="text-left text color-white-c"
										>Contract Value</span
									>
									<div class="text-right float-right text-white">
										{{ currencySymbol }}
										{{ contractValueShown }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="" :style="{ display: displayEditRowButton }">
					<div class="flex justify-between flex--same-width gap-2">
						<button
							id="buttonCloseEditOrder"
							type="button"
							class="btn bg-grey-6"
							@click="cancelEditForm()"
						>
							Cancel
						</button>

						<!-- <button id="buttonCloseTradeTicket" type="button" class="col btn c-btn-danger px-0 mr-3" data-dismiss="modal" @click="resetValue()">Close</button> -->
						<button
							type="button"
							class="btn c-btn-theme"
							:disabled="detailOrder.direction == 'sell' && !disclaimerCheck"
							@click="confirmSubmit()"
						>
							Submit
						</button>
					</div>
				</div>

				<div class="" :style="{ display: displayOriginalRowButton }">
					<div
						v-if="detailOrder.status == 'submit'"
						class="flex justify-between flex--same-width gap-2 mb-2"
					>
						<button
							id="buttonCloseDetailOrder"
							type="button"
							class="btn bg-grey-6 color-red-c"
							@click="deleteOrder(orderId)"
						>
							KILL
						</button>
						<button
							id="buttonCloseDetailOrder"
							type="button"
							class="btn bg-grey-6 color-theme-c"
							@click="showEditForm()"
						>
							EDIT
						</button>
					</div>

					<button
						id="buttonCloseDetailOrder"
						type="button"
						class="w-full btn c-btn-theme"
						@click="closeDetailOrder()"
					>
						Close
					</button>

					<!-- <div class="col-6 text-left">
						<button id="buttonCloseDetailOrder" type="button" class="btn btn-sm btn-secondary"
							@click="closeModal()">Close</button>
					</div>
					<div v-if="this.$store.getters.getAccountLevel != 'ib' && this.$store.getters.getAccountLevel != 'fm' && this.$store.getters.getAccountLevel != 'ccp' && this.$store.getters.getAccountLevel != 'lp' && this.$store.getters.getBrokerName != 'pospaygold' " class="col-6 text-right">
						<button type="button" class="btn btn-sm btn-warning mr-2" :style="{ display: displayEdit }" @click="showEditForm()">Edit</button>
						<button type="button" class="btn btn-sm btn-danger" :style="{ display: displayKill }" @click="deleteOrder(orderId)">Kill</button>
					</div> -->
				</div>
			</div>

			<div v-else>
				<div class="row">
					<div class="col-12 text-center my-5">
						<Loader size_prop="10em"></Loader>
					</div>
				</div>

				<button
					id="buttonCloseDetailOrder"
					type="button"
					class="w-full btn c-btn-theme"
					@click="closeModal()"
				>
					Close
				</button>
			</div>

			<!-- <Alert ref="alertRef" :disableButton="disableButton" @closeAlert="closeAlert">
				<div v-if="direction == 'sell'">
					<div class="title-alert">Settlement dana penjualan berlangsung dalam T+0 hingga maksimal T+5 hari kerja
					</div>
					<div class="text-alert">Settlement dapat berlangsung hingga T+5 hari kerja jika terjadi antrean penyepadanan
						dan
						penyelesaian transaksi parsial secara multilateral. Anda akan menerima dana (settlement amount) sesuai
						dengan
						harga saat transaksi penjualan. Emas fisik milik anda tetap tersimpan aman selama proses ini.
					</div>
					<div class="mb-8 text-left">
						<label class="flex flex--justify-content-start flex--align-items-center text-white cursor-hover-pointer">
							<input type="checkbox" v-model="disclaimerCheck">
							I understand and agree to the terms and conditions
						</label>
					</div>
				</div>
			</Alert> -->
		</div>
	</ModalComponent>
</template>

<script>
	import axios from "@/api/axios.js"
	import Swal from "sweetalert2"
	import { Decimal } from "decimal.js"

	import { EVENT_KEYS } from "../../../internal/events"

	import Alert from "../../alert-component/AlertComponent"

	import TradingFormula, { currencyFormat, getPnl } from "@bei/trading-formula"
	import Utils from "@/utils/index.js"

	import Loader from "@/components/Loader.vue"
	// import Alert from '@/components/Alert.vue'
	import ModalComponent from "../../ModalComponent.vue"
	import Cashback from "../../Cashback.vue"
	import Tooltip from "@/components/Tooltip.vue"
	import TooltipRincianOrder from "../../tradeticket/TooltipRincianOrder.vue"
	import { totalTypeA } from "@bei/trading-formula/reports/orders/detailOrder"
	import TooltipEstimateMaximumPayment from "../../tradeticket/TooltipEstimateMaximumPayment.vue"

	export default {
		name: "DetailOrder",

		components: {
			Loader,
			Tooltip,
			ModalComponent,
			Cashback,
			Tooltip,
			TooltipRincianOrder,
			TooltipEstimateMaximumPayment,
		},

		props: {
			data_prop: {
				type: Object,
				default: () => {
					return {}
				},
			},

			transactionId_prop: {
				type: String,
				default: null,
			},

			account_prop: {
				type: String,
				default: "Account",
			},
			ticker_prop: {
				type: String,
				default: "KAU_USD",
			},
			name: {
				type: String,
				default: "Default",
			},
			orderId_prop: {
				type: String,
				default: "",
			},
			contractId_prop: {
				type: Number | String,
				default: -1,
			},
			status_prop: {
				type: String,
				default: "submit",
			},
			direction_prop: {
				type: String,
				default: "buy",
			},
			type_prop: {
				type: String,
				default: "limit",
			},
			validity_prop: {
				type: String,
				default: "GTC",
			},
			validUntil_prop: {
				type: String,
				default: "Until Cancel",
			},
			pricePerGram_prop: {
				type: Number,
				default: 0,
			},
			totalGram_prop: {
				type: Number,
				default: 0,
			},
			contractPrice_prop: {
				type: Number,
				default: 0,
			},
			quantity_prop: {
				type: Number,
				default: 0,
			},
			contractValue_prop: {
				type: Number,
				default: 0,
			},
			modalOpen_prop: {
				type: Boolean,
				default: false,
			},
			feeFilled_prop: {
				type: Number,
				default: -1,
			},
			taxFilled_prop: {
				type: Number,
				default: -1,
			},
			totalUsdFilled_prop: {
				type: Number,
				default: -1,
			},
		},
		data() {
			return {
				Decimal: Decimal,
				publicPath: process.env.BASE_URL,
				colorGrey8: getComputedStyle(document.documentElement).getPropertyValue(
					"--color-grey8",
				),

				formControl: false,
				formControlPlaintext: true,
				originalQuantity: 0,
				originalPricePerOzt: 0,
				originalContractPrice: 0,
				displayFormOriginal: "flex",
				displayFormEdit: "none",
				displayOriginalRowButton: "block",
				displayEditRowButton: "none",
				varia: true,
				displayFormOriginalOpenValue: "-",
				displayFormOriginalFilledValue: "-",
				displayFormOriginalKilledValue: "-",
				limitOrderDate: "",
				limitOrderTime: "",

				quantityIntEdit: 0,
				quantityDecimalEdit: 0,

				pricePerGramEdit: 0,

				detailOrder: {},

				getDetailOrder_Status: "idle",
				getDetailOrder_StatusMessage: "",

				// minExpiryDateInInput:`${today.getFullYear()}-${today.getMonth() + 1 < 10 ? '0' : ''}${today.getMonth() + 1}-${today.getDate() + 1 < 10 ? '0' : ''}${today.getDate() + 1}`
				disclaimerCheck: false,

				setIntervalFetchGoldInventory: null,
			}
		},

		computed: {
			EVENT_KEYS() {
				return EVENT_KEYS
			},

			displayFormOriginalOpen: {
				get: function () {
					if (
						this.displayFormOriginalOpenValue == "-" &&
						this.displayFormOriginalFilledValue == "-" &&
						this.displayFormOriginalKilledValue == "-"
					) {
						if (this.$parent.filterStatus == "submit") {
							return "flex"
						} else {
							return "none"
						}
					} else {
						return this.displayFormOriginalOpenValue
					}
				},
				set: function (value) {
					this.displayFormOriginalOpenValue = value
				},
			},
			displayFormOriginalFilled: {
				get: function () {
					if (
						this.displayFormOriginalOpenValue == "-" &&
						this.displayFormOriginalFilledValue == "-" &&
						this.displayFormOriginalKilledValue == "-"
					) {
						if (this.$parent.filterStatus == "fill") {
							return "flex"
						} else {
							return "none"
						}
					} else {
						return this.displayFormOriginalFilledValue
					}
				},
				set: function (value) {
					this.displayFormOriginalFilledValue = value
				},
			},
			displayFormOriginalKilled: {
				get: function () {
					if (
						this.displayFormOriginalOpenValue == "-" &&
						this.displayFormOriginalFilledValue == "-" &&
						this.displayFormOriginalKilledValue == "-"
					) {
						if (this.$parent.filterStatus == "cancel") {
							return "flex"
						} else {
							return "none"
						}
					} else {
						return this.displayFormOriginalKilledValue
					}
				},
				set: function (value) {
					this.displayFormOriginalKilledValue = value
				},
			},
			modalOpen() {
				return this.modalOpen_prop
			},
			modalClass() {
				return {
					modalDialog: true,
					"modal-open": true,
				}
			},
			inputClass() {
				return {
					"form-control": this.formControl,
					"form-control-plaintext": this.formControlPlaintext,
					"form-control-sm": true,
					"px-2": true,
				}
			},

			currency() {
				return this.$store.state.currency
			},

			isEventRogActive() {
				const eventStatus = this.$store.getters["events/getEventStatus"](
					EVENT_KEYS.rog,
				)

				return eventStatus == "ongoing" ? true : false
			},

			streamingRate() {
				return this.$store.getters.getStreamingRate
			},

			streamingRateSell() {
				if (!this.data_prop.rate) {
					return this.streamingRate.streamSell
				} else {
					return this.data_prop.rate
				}
			},

			streamingRateBuy() {
				if (!this.data_prop.rate) {
					return this.streamingRate.streamBuy
				} else {
					return this.data_prop.rate
				}
			},

			streamingRateDynamic() {
				if (!this.data_prop.rate) {
					return this.currency == "idr"
						? this.direction == "buy"
							? this.streamingRate.streamBuy
							: this.streamingRate.streamSell
						: 1
				} else {
					return this.currency == "idr" ? this.data_prop.rate : 1
				}
			},

			products() {
				return this.$store.getters.PRODUCTS
			},

			minMaxLimitPrice() {
				const contractConfig = this.$store.getters.getContractConfigs(
					this.detailOrder.contractId,
				)
				if (contractConfig.contractType == "kau") {
					return this.$store.state.minMaxLimitPriceKAU
				}
				return this.$store.state.minMaxLimitPriceIGX
			},

			goldBalance() {
				const temp = this.$store.getters.getGoldBalanceByContractId(
					this.detailOrder.contractId,
				)

				return temp
			},

			sellPrice() {
				let gold = this.$store.getters.goldById(this.detailOrder.contractId)
				if (gold) {
					if (gold.sell < 0 || gold.id == 0) {
						if (gold.buy < 0 || gold.id == 0) {
							return "-"
						} else {
							return gold.buy
						}
					} else {
						return gold.sell
					}
				} else {
					return "-"
				}
			},
			buyPrice() {
				let gold = this.$store.getters.goldById(this.detailOrder.contractId)
				if (gold) {
					if (gold.buy < 0 || gold.id == 0) {
						if (gold.sell < 0 || gold.id == 0) {
							return "-"
						} else {
							return gold.sell
						}
					} else {
						return gold.buy
					}
				} else {
					return "-"
				}
			},

			account() {
				return this.account_prop
			},
			orderId() {
				return this.orderId_prop
			},
			status() {
				if (this.$parent.filterStatus == "submit") {
					return "submit"
				} else if (this.$parent.filterStatus == "fill") {
					return "fill"
				} else {
					return "cancel"
				}
			},
			direction() {
				return this.detailOrder.direction
			},
			type() {
				return this.type_prop
			},
			validUntil() {
				return this.validUntil_prop
			},

			pricePerGram() {
				return Decimal.mul(
					this.pricePerGram_prop,
					this.streamingRateDynamic,
				).toFixed(2)
			},
			pricePerGramShown() {
				console.log("pricePerGramUsd", this.detailOrder)
				if (this.currency == "usd") {
					return Utils.currencyFormat(this.detailOrder.pricePerGramUsd, "usd")
				} else {
					return Utils.currencyFormat(this.detailOrder.pricePerGramIdr, "idr")
				}
			},

			totalGram() {
				return this.totalGram_prop
			},

			contractPrice() {
				return Decimal.mul(
					this.contractPrice_prop,
					this.streamingRateDynamic,
				).toFixed(2)
			},
			contractPriceShown() {
				if (this.currency == "usd") {
					return Utils.currencyFormat(this.detailOrder.contractPriceUsd, "usd")
				} else {
					return Utils.currencyFormat(this.detailOrder.contractPriceIdr, "idr")
				}
			},

			contractValue() {
				return new Decimal(this.contractValue_prop).toFixed(2)
			},
			contractValueShown() {
				if (this.currency == "usd") {
					return Utils.currencyFormat(this.detailOrder.contractValueUsd, "usd")
				} else {
					return Utils.currencyFormat(this.detailOrder.contractValueIdr, "idr")
				}
			},

			minusSignDetailOrder() {
				const contractValue =
					this.currency == "idr"
						? this.detailOrder.contractValueIdr
						: this.detailOrder.contractValueUsd
				if (this.direction == "buy" || contractValue == 0) {
					return ""
				} else {
					return "-"
				}
			},

			fee() {
				if (!this.data_prop.fee) {
					return Number(this.data_prop.fee)
				} else {
					let temp = new Decimal(this.contractValue)
						.mul(this.$store.state.fee)
						.toDecimalPlaces(3)
					if (temp.lessThan(this.$store.state.feeMin)) {
						return new Decimal(this.$store.state.feeMin)
					}
					return temp
				}
			},
			feeShown() {
				if (this.currency == "usd") {
					return Utils.currencyFormat(
						new Decimal(
							this.detailOrder.feeUsd,
							this.$store.state.fractionDigit.usd,
						),
					)
				} else {
					return Utils.currencyFormat(
						new Decimal(
							this.detailOrder.feeIdr,
							this.$store.state.fractionDigit.idr,
						),
					)
				}
			},

			tax() {
				if (!this.data_prop.tax) {
					return Number(this.data_prop.tax)
				} else {
					let temp = new Decimal(this.fee)
						.mul(this.$store.state.tax)
						.toDecimalPlaces(3)
					if (temp.lessThan(this.$store.state.taxMin)) {
						return new Decimal(this.$store.state.taxMin)
					}
					return temp
				}
			},
			taxShown() {
				if (this.currency == "usd") {
					return Utils.currencyFormat(
						new Decimal(
							this.detailOrder.taxUsd,
							this.$store.state.fractionDigit.usd,
						),
					)
				} else {
					return Utils.currencyFormat(
						new Decimal(
							this.detailOrder.taxIdr,
							this.$store.state.fractionDigit.idr,
						),
					)
				}
			},

			totalTypeAShown() {
				if (this.currency == "usd") {
					return Utils.currencyFormat(
						new Decimal(this.detailOrder.totalTypeAUsd),
					)
				} else {
					return Utils.currencyFormat(
						new Decimal(this.detailOrder.totalTypeAIdr),
					)
				}
			},

			fxBuffer() {
				let temp = new Decimal(this.contractValue)
					.mul(this.$store.state.fxBuffer)
					.toDecimalPlaces(2)
				if (new Decimal(this.contractValue).lessThanOrEqualTo(0)) {
					return new Decimal(0)
				} else if (temp.lessThan(this.$store.state.fxBufferMin)) {
					return new Decimal(this.$store.state.fxBufferMin)
				}

				return temp
			},
			fxBufferShown() {
				return Utils.currencyFormat(this.detailOrder.fxBufferIdr, "idr")
			},

			totalUsdLimitShown() {
				return Utils.currencyFormat(this.detailOrder.estimatedPriceUsd, "usd")
			},

			totalIdrLimitShown() {
				return Utils.currencyFormat(this.detailOrder.estimatedPriceIdr, "idr")
			},

			metalValueOfTradeShown() {
				if (this.currency == "usd") {
					return Utils.currencyFormat(
						this.detailOrder.metalValueOfTradeUsd,
						"usd",
					)
				} else {
					return Utils.currencyFormat(
						this.detailOrder.metalValueOfTradeIdr,
						"idr",
					)
				}
			},

			settlementAmountUsdShown() {
				return Utils.currencyFormat(this.detailOrder.settlementAmountUsd, "usd")
			},

			settlementAmountIdrShown() {
				return Utils.currencyFormat(this.detailOrder.settlementAmountIdr, "idr")
			},

			displayEdit() {
				let display = ""
				if (
					this.type_prop == "limit" &&
					this.$parent.filterStatus == "submit"
				) {
					display = "initial"
				} else {
					display = "none"
				}
				return display
			},
			displayKill() {
				let display = ""
				if (this.$parent.filterStatus == "submit") {
					display = "initial"
				} else {
					display = "none"
				}
				return display
			},
			feeFilled() {
				if (!this.data_prop.fee) {
					return "-"
				}
				return this.data_prop.fee.toFixed(3)
			},
			taxFilled() {
				if (!this.data_prop.tax) {
					return "-"
				}
				return this.data_prop.tax.toFixed(3)
			},
			totalUsdFilled() {
				if (!this.data_prop.paymentUsd) {
					return "-"
				}
				return this.numberFormatExtend(this.data_prop.paymentUsd.toFixed(2))
			},
			totalIdrFilled() {
				if (!this.data_prop.paymentIdr) {
					return "-"
				}
				return this.numberFormatExtend(this.data_prop.paymentUsd.toFixed(2))
			},

			minExpiryDateInInput() {
				const dateNow = new Date()

				const day =
					dateNow.getDate() < 10 ? "0" + dateNow.getDate() : dateNow.getDate()
				const month =
					dateNow.getMonth() + 1 < 10
						? "0" + (dateNow.getMonth() + 1)
						: dateNow.getMonth() + 1
				const year =
					dateNow.getFullYear() < 10
						? "0" + dateNow.getFullYear()
						: dateNow.getFullYear()
				const hours =
					dateNow.getHours() < 10
						? "0" + dateNow.getHours()
						: dateNow.getHours()
				const minutes =
					dateNow.getMinutes() < 10
						? "0" + dateNow.getMinutes()
						: dateNow.getMinutes()

				const dateTemp =
					year + "-" + month + "-" + day + " " + hours + ":" + minutes

				return dateTemp
			},

			expiryDate() {
				let date = new Date(this.limitOrderDate) // default GTD
				if (this.detailOrder.validity == "GTC") {
					let tempToday = new Date(Date.now())
					date = new Date(tempToday.setMonth(tempToday.getMonth() + 1)) // set +1 month from now
				}

				return date
			},

			dataEditUsd() {
				let rate
				if (this.detailOrder.direction == "buy") {
					rate = this.streamingRate.streamBuy
				} else {
					rate = this.streamingRate.streamSell
				}

				let pricePerGram = this.pricePerGramEdit

				if (pricePerGram == "-") {
					pricePerGram = 0
				}

				const contractConfig = this.$store.getters.getContractConfigs(
					this.detailOrder.contractId,
				)

				// make it before manipulated
				pricePerGram = Decimal.div(
					pricePerGram,
					contractConfig.weightCorrection,
				).toNumber()

				const quantity = new Decimal(this.quantityEdit).toNumber()

				const param = {
					quantity: quantity,
					pricePerGramUsd: pricePerGram,
					contractWeight: contractConfig.weightInGram,
					direction: this.direction,
					orderType: this.detailOrder.type,
					currency: "usd",
					rateUsdToCurrency: rate || -1,
					rateCurrencyToIdr: rate,
				}
				const tradingData = TradingFormula.tradeTicket.tradeTicketData(param)

				return tradingData
			},

			dataEditIdr() {
				let rate
				if (this.detailOrder.direction == "buy") {
					rate = this.streamingRate.streamBuy
				} else {
					rate = this.streamingRate.streamSell
				}

				let pricePerGram = this.pricePerGramEdit
				if (pricePerGram == "-") {
					pricePerGram = 0
				}
				const contractConfig = this.$store.getters.getContractConfigs(
					this.detailOrder.contractId,
				)

				// make it before manipulated
				pricePerGram = Decimal.div(
					pricePerGram,
					contractConfig.weightCorrection,
				).toNumber()

				const quantity = new Decimal(this.quantityEdit).toNumber()

				const param = {
					quantity: quantity,
					pricePerGramUsd: pricePerGram,
					contractWeight: contractConfig.weightInGram,
					direction: this.direction,
					orderType: this.detailOrder.type,
					currency: "idr",
					rateUsdToCurrency: rate || -1,
					rateCurrencyToIdr: rate,
				}
				const tradingData = TradingFormula.tradeTicket.tradeTicketData(param)

				return tradingData
			},

			quantityIntEditInInput: {
				get: function () {
					const temp = new Decimal(this.quantityIntEdit)
					if (!temp.isInteger()) {
						this.quantityIntEdit = temp.floor().toNumber()
					}

					return this.quantityIntEdit
				},
				set: function (newValue) {
					let temp = Number(newValue)
					if (!Number.isInteger(temp)) {
						temp = Math.round(temp)
					}

					this.checkQuantityIntEdit(temp)
				},
			},
			quantityDecimalEditInInput: {
				get: function () {
					return this.quantityDecimalEdit
				},
				set: function (newValue) {
					let temp = new Decimal(newValue)
					if (temp.greaterThanOrEqualTo(1)) {
						this.quantityDecimalEdit = new Decimal(0.9)
					} else if (temp.lessThan(0)) {
						this.quantityDecimalEdit = new Decimal(0)
					} else {
						this.quantityDecimalEdit = new Decimal(
							temp.toFixed(1, Decimal.ROUND_FLOOR),
						)
					}
				},
			},
			quantityEdit() {
				return Decimal.add(this.quantityIntEdit, this.quantityDecimalEdit)
			},

			pricePerGramEditInInput: {
				get: function () {
					return new Decimal(this.pricePerGramEdit).toNumber()
				},
				set: function (newValue) {
					let temp = new Decimal(newValue)
					if (temp.lessThan(0)) {
						this.pricePerGramEdit = new Decimal(0)
					} else {
						const decimalPlaces = this.$store.state.fractionDigit.usd
						this.pricePerGramEdit = new Decimal(temp).toDecimalPlaces(
							decimalPlaces,
						)
					}
				},
			},

			contractPriceEditUsd() {
				// const decimalPlaces = this.$store.state.fractionDigit.usd

				// const contractPriceEditUsd = Decimal.mul(this.pricePerGramEdit, this.$store.state.contractConfigs[this.detailOrder.contractId].weightMultiplication).toFixed(decimalPlaces)
				// return contractPriceEditUsd

				return this.dataEditUsd.contractPrice
			},
			contractPriceEditIdr() {
				return this.dataEditIdr.contractPrice
			},
			contractPriceEditShown() {
				// const decimalPlaces = this.currency == 'usd' ? this.$store.state.fractionDigit.usd : this.$store.state.fractionDigit.idr

				// const temp = Decimal.mul(this.contractPriceEditUsd, this.streamingRateDynamic).toFixed(decimalPlaces)
				// return Utils.currencyFormat(temp)

				if (this.currency == "usd") {
					return Utils.currencyFormat(this.contractPriceEditUsd)
				} else {
					return Utils.currencyFormat(this.contractPriceEditIdr)
				}
			},

			gram() {
				if (
					Decimal.mul(
						this.quantityEdit,
						this.$store.state.contractConfigs[this.detailOrder.contractId]
							.weightInGram,
					).greaterThanOrEqualTo(0)
				) {
					return Decimal.mul(
						this.quantityEdit,
						this.$store.state.contractConfigs[this.detailOrder.contractId]
							.weightInGram,
					)
				} else {
					return 0
				}
			},
			gramShown() {
				return this.numberFormatExtend(this.gram)
			},

			contractValueEditUsd() {
				return this.dataEditUsd.contractValue
			},

			contractValueEditIdr() {
				return this.dataEditIdr.contractValue
			},
			contractValueEditShown() {
				if (this.currency == "usd") {
					return Utils.currencyFormat(this.contractValueEditUsd)
				} else {
					return Utils.currencyFormat(this.contractValueEditIdr)
				}
			},

			minusSignEditOrder() {
				const contractValue =
					this.currency == "idr"
						? this.contractValueEditIdr
						: this.contractValueEditUsd
				if (this.direction == "buy" || contractValue == 0) {
					return ""
				} else {
					return "-"
				}
			},

			feeEditUsd() {
				// let temp = new Decimal(this.contractValueEditUsd).times(this.$store.state.fee).toDecimalPlaces(3)
				// if (new Decimal(this.contractValueEditUsd).lessThanOrEqualTo(0)) {
				// 	return new Decimal(0)
				// } else if (temp.lessThan(this.$store.state.feeMin)) {
				// 	return new Decimal(this.$store.state.feeMin)
				// }
				// return temp

				const feeEditUsd = this.dataEditUsd.fee

				return feeEditUsd
			},
			feeEditIdr() {
				const feeEditIdr = this.dataEditIdr.fee

				return feeEditIdr
			},
			feeEditShown() {
				// if (this.currency == 'usd') {
				// 	return this.numberFormatExtend((this.feeEditUsd).times(this.streamingRateDynamic).toFixed(3), 3)
				// } else {
				// 	return this.numberFormatExtend((this.feeEditUsd).times(this.streamingRateDynamic).toFixed(2))
				// }

				if (this.currency == "usd") {
					return Utils.currencyFormat(this.feeEditUsd, "usd")
				} else {
					return Utils.currencyFormat(this.feeEditIdr, "idr")
				}
			},

			taxEditUsd() {
				// let temp = new Decimal(this.feeEditUsd).times(this.$store.state.tax).toDecimalPlaces(3)
				// if (new Decimal(this.contractValueEditUsd).lessThanOrEqualTo(0)) {
				// 	return new Decimal(0)
				// } else if (temp.lessThan(this.$store.state.taxMin)) {
				// 	return new Decimal(this.$store.state.taxMin)
				// }
				// return temp

				const taxEditUsd = this.dataEditUsd.tax

				return taxEditUsd
			},
			taxEditIdr() {
				const taxEditIdr = this.dataEditIdr.tax

				return taxEditIdr
			},
			taxEditShown() {
				// if (this.currency == 'usd') {
				// 	return this.numberFormatExtend((this.taxEditUsd).times(this.streamingRateDynamic).toFixed(3), 3)
				// } else {
				// 	return this.numberFormatExtend((this.taxEditUsd).times(this.streamingRateDynamic).toFixed(2))
				// }

				if (this.currency == "usd") {
					return Utils.currencyFormat(this.taxEditUsd, "usd")
				} else {
					return Utils.currencyFormat(this.taxEditIdr, "idr")
				}
			},

			totalTypeAEdit() {
				if (this.currency == "usd") {
					return this.dataEditUsd.totalTypeA
				} else {
					return this.dataEditIdr.totalTypeA
				}
			},
			totalTypeAEditShown() {
				return Utils.currencyFormat(this.totalTypeAEdit)
			},

			storageFee() {
				return 0
			},
			storageFeeShown() {
				return Utils.currencyFormat(this.storageFee)
			},

			fxBufferEditUsd() {
				// let temp = new Decimal(this.contractValueEditUsd).times(this.$store.state.fxBuffer).toDecimalPlaces(2)
				// if (new Decimal(this.contractValueEditUsd).lessThanOrEqualTo(0)) {
				// 	return new Decimal(0)
				// } else if (temp.lessThan(this.$store.state.fxBufferMin)) {
				// 	return new Decimal(this.$store.state.fxBufferMin)
				// }
				// return temp

				const fxBufferEditUsd = this.dataEditUsd.fxBuffer

				return fxBufferEditUsd
			},
			fxBufferEditIdr() {
				const fxBufferEditIdr = this.dataEditIdr.fxBuffer

				return fxBufferEditIdr
			},
			fxBufferEditShown() {
				// return this.numberFormatExtend(Decimal.mul(this.streamingRateBuy, this.fxBufferEditUsd).toFixed(2))
				return Utils.currencyFormat(this.fxBufferEditIdr, "idr")
			},

			totalUsdLimitEdit() {
				// let temp = new Decimal(this.contractValueEditUsd)
				// if (this.direction == 'buy') {
				// 	temp = temp.plus(this.taxEditUsd).plus(this.feeEditUsd)
				// } else {
				// 	temp = temp.minus(this.taxEditUsd).minus(this.feeEditUsd)
				// }
				// return Number(temp.toFixed(2))

				const totalUsdLimitEdit = this.dataEditUsd.total

				return totalUsdLimitEdit
			},
			totalUsdLimitEditShown() {
				return Utils.currencyFormat(this.totalUsdLimitEdit, "usd")
			},

			totalIdrLimitEdit() {
				// let temp = new Decimal(this.totalUsdLimitEdit)

				// if (this.direction == 'buy') {
				// 	return temp.times(this.streamingRateBuy).plus(Decimal.mul(this.streamingRateBuy, this.fxBufferEditUsd)).toFixed(2)
				// } else {
				// 	return temp.times(this.streamingRateSell).toFixed(2)
				// }

				const totalIdrLimitEdit = this.dataEditIdr.total

				return totalIdrLimitEdit
			},
			totalIdrLimitEditShown() {
				return Utils.currencyFormat(this.totalIdrLimitEdit, "idr")
			},

			estimasiProfitEditIdr() {
				if (this.direction == "buy") {
					return 0
				}

				const stack = this.$store.getters[
					"goldInventories/getTradeGoldInventoriesByContractId"
				](this.detailOrder.contractId).map((item) => ({
					gram: item.remaining_quantity,
					pricePerGram: item.cost_per_gram_idr,
				}))

				const metalValueAtDate = this.dataEditIdr.total

				const estimasiProfit = getPnl({
					stack: stack,
					gramSell: this.gram.toNumber(),
					metalValueAtDate: metalValueAtDate,
					currency: "idr",
					paymentMethod: this.$store.getters.paymentMethod,
				})

				return estimasiProfit.pnl
			},

			estimasiProfitEditUsd() {
				if (this.direction == "buy") {
					return 0
				}

				const stack = this.$store.getters[
					"goldInventories/getTradeGoldInventoriesByContractId"
				](this.detailOrder.contractId).map((item) => ({
					gram: item.remaining_quantity,
					pricePerGram: item.cost_per_gram_usd,
				}))

				const metalValueAtDate = this.dataEditUsd.total

				const estimasiProfit = getPnl({
					stack: stack,
					gramSell: this.gram.toNumber(),
					metalValueAtDate: metalValueAtDate,
					currency: "usd",
					paymentMethod: this.$store.getters.paymentMethod,
				})

				return estimasiProfit.pnl
			},

			estimasiProfitEditShown() {
				if (this.$store.state.goldInventories.apiStatus == "loading") {
					return "-"
				}

				const estimasiProfit =
					this.currency == "idr"
						? this.estimasiProfitEditIdr
						: this.estimasiProfitEditUsd

				// if estimated profit < 0 show minus sign before the currency
				let minSign = ""
				if (new Decimal(estimasiProfit).lessThan(0)) {
					minSign = "-"
				}

				// if payment method is rped fraction digit is the same as the currency, else it is 0
				const fractionDigit =
					this.$store.getters.paymentMethod === "rped"
						? this.$store.state.fractionDigit[this.currency]
						: this.currency === "idr"
						? 0
						: this.$store.state.fractionDigit[this.currency]

				return (
					`${minSign}${this.currency == "idr" ? "Rp" : "$"} ` +
					Utils.currencyFormat(
						new Decimal(estimasiProfit).abs().toFixed(),
						this.currency,
					)
				)
			},

			pnlUsdEdit() {
				if (
					this.$store.state.setHoldingsApiStatus == "success" &&
					this.detailOrder.contractId != "0" &&
					this.detailOrder.contractId
				) {
					// const holding = this.$store.getters.getHoldingByContractId(this.contractId_prop)
					// const tempPnl = this.$store.getters.getEstimatePNLUsdByContractIdForJfxChamp(this.contractId_prop, this.pricePerGramEdit)
					// const pnlPerGram = Decimal.div(tempPnl, Decimal.mul(holding.quantity, this.$store.state.contractConfigs[this.contractId_prop].weightInGram)).toDecimalPlaces(4).toNumber()

					// return Decimal.mul(pnlPerGram, this.gram).toDecimalPlaces(4, Decimal.ROUND_FLOOR).toNumber()

					const holding = this.$store.getters.getHoldingByContractId(
						this.detailOrder.contractId,
					)

					let contractId
					if (
						this.accountLevel == "fm" ||
						this.accountLevel == "ib" ||
						this.accountLevel == "lp"
					) {
						contractId = holding.contractId
					} else {
						contractId = holding.contract_id
					}

					if (!this.$store.state.golds[contractId]) {
						return "-"
					}

					const contractConfig =
						this.$store.getters.getContractConfigs(contractId)
					const contractPriceUsd = Decimal.mul(
						this.pricePerGramEdit,
						contractConfig.weightMultiplication,
					).toNumber()

					let averageTotalCostIncFeeAndTax
					if (this.accountLevel == "fm" || this.accountLevel == "ib") {
						averageTotalCostIncFeeAndTax =
							holding.averageTotalCostIncFeeAndTaxUsd
					} else {
						averageTotalCostIncFeeAndTax = holding.avg_total_cost
					}

					const rate = this.streamingRate.streamSell

					const pnlUsd =
						TradingFormula.reports.holdings.getEstimatePnlForJfxChamp({
							contractPriceUsd: contractPriceUsd,
							averageTotalCostIncFeeAndTax: averageTotalCostIncFeeAndTax,
							quantityHolding: holding.quantity,
							contractWeight:
								this.$store.state.contractConfigs[contractId].weightInGram,
							gramOrder: this.gram.toNumber(),
							currency: "usd",
							rate: rate,
						})

					return new Decimal(pnlUsd).toNumber()
				}

				return null
			},
			pnlIdrEdit() {
				if (
					this.$store.state.setHoldingsApiStatus == "success" &&
					this.detailOrder.contractId != "0" &&
					this.detailOrder.contractId
				) {
					// const holding = this.$store.getters.getHoldingByContractId(this.detailOrder.contractId)
					// const tempPnl = this.$store.getters.getEstimatePNLIdrByContractIdForJfxChamp(this.detailOrder.contractId, this.pricePerGramEdit)
					// const pnlPerGram = Decimal.div(tempPnl, Decimal.mul(holding.quantity, this.$store.state.contractConfigs[this.detailOrder.contractId].weightInGram)).toDecimalPlaces(4).toNumber()

					// return Decimal.mul(pnlPerGram, this.gram).toDecimalPlaces(4, Decimal.ROUND_FLOOR).toNumber()

					const holding = this.$store.getters.getHoldingByContractId(
						this.detailOrder.contractId,
					)

					if (this.streamingRate.streamSell == -1 && this.currency != "usd") {
						return "-"
					}

					let contractId
					if (
						this.accountLevel == "fm" ||
						this.accountLevel == "ib" ||
						this.accountLevel == "lp"
					) {
						contractId = holding.contractId
					} else {
						contractId = holding.contract_id
					}

					if (!this.$store.state.golds[contractId]) {
						return "-"
					}

					const contractConfig =
						this.$store.getters.getContractConfigs(contractId)
					const contractPriceUsd = Decimal.mul(
						this.pricePerGramEdit,
						contractConfig.weightMultiplication,
					).toNumber()

					let averageTotalCostIncFeeAndTax
					if (this.accountLevel == "fm" || this.accountLevel == "ib") {
						averageTotalCostIncFeeAndTax =
							holding.averageTotalCostIncFeeAndTaxIdr
					} else {
						averageTotalCostIncFeeAndTax = holding.avg_total_cost_idr
					}

					const rate = this.streamingRate.streamSell

					const pnlIdr =
						TradingFormula.reports.holdings.getEstimatePnlForJfxChamp({
							contractPriceUsd: contractPriceUsd,
							averageTotalCostIncFeeAndTax: averageTotalCostIncFeeAndTax,
							quantityHolding: holding.quantity,
							contractWeight:
								this.$store.state.contractConfigs[contractId].weightInGram,
							gramOrder: this.gram.toNumber(),
							currency: "idr",
							rate: rate,
						})

					return new Decimal(pnlIdr).toNumber()
				}

				return null
			},

			priceOzt15PercentAway() {
				let price = "-"
				if (this.direction == "buy") {
					price = this.buyPrice
				} else {
					price = this.sellPrice
				}
				if (price != "-") {
					price = new Decimal(price)
					let temp = new Decimal(this.pricePerGramEdit)

					if (
						temp.lessThanOrEqualTo(
							price.minus(price.times(this.minMaxLimitPrice)),
						) ||
						temp.greaterThanOrEqualTo(
							price.plus(price.times(this.minMaxLimitPrice)),
						)
					) {
						return true
					}
				}
				return false
			},
		},

		watch: {
			orderId_prop() {
				this.setDetailOrder()
			},
			transactionId_prop() {
				this.setDetailOrder()
			},

			quantity_prop(newValue) {
				this.quantityIntEdit = Math.floor(newValue)

				this.quantityDecimalEdit = Decimal.mod(newValue, 1)
				if (
					!this.$store.state.contractConfigs[this.detailOrder.contractId]
						.hasQuantityDecimal
				) {
					this.quantityDecimalEdit = 0
				}
			},
			// pricePerGram_prop(newValue) {
			// 	this.pricePerGramEdit = newValue
			// },
			validUntil_prop(newValue) {
				this.limitOrderDate = `${newValue.substr(0, 4)}-${newValue.substr(
					5,
					2,
				)}-${newValue.substr(8, 2)} ${newValue.substr(11, 2)}:${newValue.substr(
					14,
					2,
				)}`
			},

			limitOrderDate(newValue) {
				const now = new Date()
				const expiryDate = new Date(newValue)

				const temp = new Date(now.setHours(now.getHours() + 1))

				if (expiryDate < temp) {
					const day =
						temp.getDate() < 10 ? "0" + temp.getDate() : temp.getDate()
					const month =
						temp.getMonth() + 1 < 10
							? "0" + (temp.getMonth() + 1)
							: temp.getMonth() + 1
					const year =
						temp.getFullYear() < 10
							? "0" + temp.getFullYear()
							: temp.getFullYear()
					const hours =
						temp.getHours() < 10 ? "0" + temp.getHours() : temp.getHours()
					const minutes =
						temp.getMinutes() < 10 ? "0" + temp.getMinutes() : temp.getMinutes()

					this.limitOrderDate =
						year + "-" + month + "-" + day + " " + hours + ":" + minutes
				}
			},
		},

		created() {
			this.limitOrderDate = `${this.validUntil_prop.substr(
				0,
				4,
			)}-${this.validUntil_prop.substr(5, 2)}-${this.validUntil_prop.substr(
				8,
				2,
			)} ${this.validUntil_prop.substr(11, 2)}:${this.validUntil_prop.substr(
				14,
				2,
			)}`

			// fetch ROG event detail
			if (this.$store.getters.paymentMethod == "rped") {
				this.$store.dispatch("events/fetchEvent", EVENT_KEYS.rog)
			}
		},

		mounted() {
			// alert setting
			// this.$refs.alertRef.changeType('confirmation')
			// this.$refs.alertRef.changeText('Are you sure want to submit this order?')
			// this.$refs.alertRef.changeButtonNoText('NO')
			// this.$refs.alertRef.changeButtonYesText('YES')
			// this.$refs.alertRef.changeNext('submit')
		},

		methods: {
			openDetailOrder() {
				// fetch gold inventories every 3 seconds
				this.$store.dispatch("goldInventories/fetchAllInventories", {
					user_id: this.$store.state.userId,
					type: "TRADE",
				})
				this.setIntervalFetchGoldInventory = setInterval(() => {
					this.$store.dispatch("goldInventories/fetchAllInventories", {
						user_id: this.$store.state.userId,
						type: "TRADE",
					})
				}, 3000)

				this.$refs.modalRef.openModal()
			},

			closeDetailOrder() {
				// clear interval fetch gold inventories
				if (this.setIntervalFetchGoldInventory) {
					clearInterval(this.setIntervalFetchGoldInventory)
					this.setIntervalFetchGoldInventory = null
				}

				this.displayFormOriginalOpen = "-"
				this.displayFormOriginalFilled = "-"
				this.displayFormOriginalKilled = "-"

				this.$refs.modalRef.closeModal()
			},

			numberFormat(value) {
				let val = value / 1
				return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") //comma separator
			},

			showDisclaimer() {
				Alert.open({
					// type: 'confirm',
					title: " ",
					description: " ",
					showIcon: false,
					showSellWarning: true,
					buttonCloseText: "OK",
					onConfirm: () => {},
				})
			},

			getDetailOrder(orderId) {
				return axios
					.post("/v2/igx/order/detail?order_id=" + orderId, {
						user_id: this.$store.state.userId,
					})
					.then((response) => {
						return response.data.data.body
					})
					.catch((error) => {
						this.getDetailOrder_Status = "error"

						if (error.response) {
							this.getDetailOrder_StatusMessage =
								error.response.data.data.err_message
						} else {
							this.getDetailOrder_StatusMessage =
								"something went wrong please try again in a few minutes"
						}

						console.error("Gagal get order", error)

						throw error
					})
			},

			async setDetailOrder() {
				this.getDetailOrder_Status = "loading"

				try {
					const detailOrder = await this.getDetailOrder(this.orderId_prop)

					// let detailOrder = response.data.data.body
					const contractConfig = this.$store.getters.getContractConfigs(
						detailOrder.attributes.contractId,
					)

					const name = contractConfig.name
					const weight = contractConfig.weightInGram
					const weightCorrection = contractConfig.weightCorrection

					const fractionDigitIdr = this.$store.state.fractionDigit.idr
					const fractionDigitUsd = this.$store.state.fractionDigit.usd

					let oneOrder
					let oneTransaction
					if (this.$parent.filterStatus == "fill") {
						oneOrder = this.$parent.orders.find(
							(obj) => obj.orderId == this.orderId_prop,
						)
						oneTransaction = this.$parent.orders.find(
							(obj) => obj.id == this.transactionId_prop,
						)
					} else {
						oneOrder = this.$parent.orders.find(
							(obj) => obj.id == this.orderId_prop,
						)
					}

					this.$set(
						this.detailOrder,
						"contractId",
						detailOrder.attributes.contractId,
					)
					this.$set(this.detailOrder, "status", this.$parent.filterStatus)
					this.$set(this.detailOrder, "account", oneOrder.account)
					this.$set(this.detailOrder, "name", name)
					this.$set(this.detailOrder, "orderId", this.orderId_prop)
					this.$set(
						this.detailOrder,
						"contractId",
						detailOrder.attributes.contractId,
					)
					this.$set(
						this.detailOrder,
						"direction",
						detailOrder.attributes.direction,
					)
					this.$set(this.detailOrder, "type", detailOrder.attributes.orderType)
					this.$set(this.detailOrder, "statusShown", this.data_prop.statusShown)

					// set streaming rate
					let rate = detailOrder.attributes.rate
					if (this.$parent.filterStatus == "fill") {
						rate = oneTransaction.responseData.attributes.rate
					}

					if (detailOrder.attributes.direction == "sell") {
						rate = this.streamingRate.streamSell
					} else {
						rate = this.streamingRate.streamBuy
					}
					this.$set(this.detailOrder, "rate", rate)

					// set validity and validUntil
					if (detailOrder.attributes.validity == "GTC") {
						this.$set(this.detailOrder, "validUntil", "Until Cancel")
						this.$set(this.detailOrder, "validity", "GTC")
					} else {
						let expiryDateTemp = new Date(detailOrder.attributes.expiryDate)
						let expiryDate = {
							year: expiryDateTemp.getFullYear(),
							month:
								expiryDateTemp.getMonth() + 1 < 10
									? `0${expiryDateTemp.getMonth() + 1}`
									: expiryDateTemp.getMonth() + 1,
							date:
								expiryDateTemp.getDate() < 10
									? `0${expiryDateTemp.getDate()}`
									: expiryDateTemp.getDate(),
							hours:
								expiryDateTemp.getHours() < 10
									? `0${expiryDateTemp.getHours()}`
									: expiryDateTemp.getHours(),
							minutes:
								expiryDateTemp.getMinutes() < 10
									? `0${expiryDateTemp.getMinutes()}`
									: expiryDateTemp.getMinutes(),
						}

						const validUntil = `${expiryDate.year}/${expiryDate.month}/${expiryDate.date} ${expiryDate.hours}:${expiryDate.minutes}`

						this.$set(this.detailOrder, "validUntil", validUntil)
						this.$set(this.detailOrder, "validity", "GTD")
					}

					// set quantity
					const quantity = Decimal.div(
						detailOrder.attributes.quantity,
						contractConfig.weightCorrection,
					).toNumber()
					this.$set(this.detailOrder, "quantity", quantity)

					// set quantityEdit
					this.quantityIntEdit = Math.floor(quantity)
					this.quantityDecimalEdit = Decimal.mod(quantity, 1)
					if (
						!this.$store.state.contractConfigs[
							detailOrder.attributes.contractId
						].hasQuantityDecimal
					) {
						this.quantityDecimalEdit = 0
					}

					// total gram
					let totalGram = Number(
						Decimal.mul(weight, detailOrder.attributes.quantity).div(
							weightCorrection,
						),
					)
					if (this.$parent.filterStatus == "fill") {
						totalGram = Number(
							Decimal.mul(
								weight,
								oneTransaction.responseData.attributes.quantity,
							).div(weightCorrection),
						)
					}
					this.$set(this.detailOrder, "totalGram", totalGram)

					// set remaining
					const remainingGram = TradingFormula.detailOrder.remainingGram({
						remaining: Decimal.mul(
							detailOrder.attributes.remaining,
							Decimal.div(weight, weightCorrection),
						).toNumber(),
					})
					// this.$set(this.detailOrder, 'remainingGram', Decimal.mul(contractConfig.weightInGram, detailOrder.attributes.remaining).div(contractConfig.weightCorrection).toNumber())
					this.$set(this.detailOrder, "remainingGram", remainingGram)

					// set price per gram
					let pricePerGramUsd = 0
					let pricePerGramIdr = 0
					if (this.$parent.filterStatus != "fill") {
						pricePerGramUsd = TradingFormula.detailOrder.pricePerGram({
							contractWeight: Decimal.div(
								contractConfig.weightMultiplication,
								contractConfig.weightCorrection,
							).toNumber(),
							limitPriceUsd: detailOrder.attributes.limitPrice,
						})
						pricePerGramIdr = TradingFormula.detailOrder.pricePerGram({
							currency: "idr",
							rate: rate,
							contractWeight: Decimal.div(
								contractConfig.weightMultiplication,
								contractConfig.weightCorrection,
							).toNumber(),
							limitPriceUsd: detailOrder.attributes.limitPrice,
						})
					} else {
						pricePerGramUsd = TradingFormula.detailOrder.pricePerGramFill({
							contractWeight: Decimal.div(
								contractConfig.weightMultiplication,
								contractConfig.weightCorrection,
							).toNumber(),
							matchPriceUsd: oneTransaction.responseData.attributes.matchPrice,
							quantity: oneTransaction.responseData.attributes.quantity,
						})
						pricePerGramIdr = TradingFormula.detailOrder.pricePerGramFill({
							currency: "idr",
							rate: rate,
							contractWeight: Decimal.div(
								contractConfig.weightMultiplication,
								contractConfig.weightCorrection,
							).toNumber(),
							matchPriceUsd: oneTransaction.responseData.attributes.matchPrice,
							quantity: oneTransaction.responseData.attributes.quantity,
						})
					}
					// this.$set(this.detailOrder, 'pricePerGramUsd', Decimal.div(detailOrder.attributes.limitPrice, contractConfig.weightMultiplication).times(contractConfig.weightCorrection).toNumber())
					this.$set(this.detailOrder, "pricePerGramUsd", pricePerGramUsd)
					this.$set(this.detailOrder, "pricePerGramIdr", pricePerGramIdr)

					// set price per gram edit
					this.pricePerGramEdit = pricePerGramUsd

					// set contract price
					const contractPriceUsd = TradingFormula.detailOrder.contractPrice({
						limitPriceUsd: Decimal.mul(
							detailOrder.attributes.limitPrice,
							contractConfig.weightCorrection,
						),
					})
					const contractPriceIdr = TradingFormula.detailOrder.contractPrice({
						currency: "idr",
						rate: rate,
						limitPriceUsd: Decimal.mul(
							detailOrder.attributes.limitPrice,
							contractConfig.weightCorrection,
						),
					})
					this.$set(this.detailOrder, "contractPriceUsd", contractPriceUsd)
					this.$set(this.detailOrder, "contractPriceIdr", contractPriceIdr)

					// set contract value
					const contractValueUsd = TradingFormula.detailOrder.contractValue({
						limitPriceUsd: detailOrder.attributes.limitPrice,
						quantity: detailOrder.attributes.quantity,
					})
					const contractValueIdr = TradingFormula.detailOrder.contractValue({
						currency: "idr",
						rate: rate,
						limitPriceUsd: detailOrder.attributes.limitPrice,
						quantity: detailOrder.attributes.quantity,
					})
					// this.$set(this.detailOrder, 'contractValue', Decimal.mul(detailOrder.attributes.limitPrice, detailOrder.attributes.quantity).toNumber())
					this.$set(this.detailOrder, "contractValueUsd", contractValueUsd)
					this.$set(this.detailOrder, "contractValueIdr", contractValueIdr)

					// set fee
					if (this.$parent.filterStatus == "submit") {
						// const feeParam = this.$parent.filterStatus == 'fill' ? oneTransaction.responseData.attributes.fee : detailOrder.attributes.fee
						// const feeUsd = TradingFormula.detailOrder.fee({
						// 	feeUsd: feeParam,
						// })
						// const feeIdr = TradingFormula.detailOrder.fee({
						// 	currency: 'idr',
						// 	rate: rate,
						// 	feeUsd: feeParam,
						// })
						this.$set(this.detailOrder, "feeUsd", detailOrder.attributes.fee)
						this.$set(this.detailOrder, "feeIdr", detailOrder.attributes.feeIdr)
					} else if (this.$parent.filterStatus == "fill") {
						this.$set(this.detailOrder, "feeUsd", this.data_prop.feeUsd)
						this.$set(this.detailOrder, "feeIdr", this.data_prop.feeIdr)
					}

					// set tax
					if (this.$parent.filterStatus == "submit") {
						// const taxParam = this.$parent.filterStatus == 'fill' ? oneTransaction.responseData.attributes.tax : detailOrder.attributes.tax
						// const taxUsd = TradingFormula.detailOrder.tax({
						// 	taxUsd: taxParam,
						// }) || '-'
						// const taxIdr = TradingFormula.detailOrder.tax({
						// 	currency: 'idr',
						// 	rate: rate,
						// 	taxUsd: taxParam,
						// }) || '-'
						this.$set(this.detailOrder, "taxUsd", detailOrder.attributes.tax)
						this.$set(this.detailOrder, "taxIdr", detailOrder.attributes.taxIdr)
					} else if (this.$parent.filterStatus == "fill") {
						this.$set(this.detailOrder, "taxUsd", this.data_prop.taxUsd)
						this.$set(this.detailOrder, "taxIdr", this.data_prop.taxIdr)
					}

					// set fxBuffer
					if (this.$parent.filterStatus == "submit") {
						const fxBufferIdr = TradingFormula.detailOrder.fxBuffer({
							fxBufferIdr: detailOrder.attributes.fxBufferIdr,
						})
						this.$set(this.detailOrder, "fxBufferIdr", fxBufferIdr)
					}

					// set total type A
					if (this.$parent.filterStatus != "cancel") {
						const totalTypeAIdr = TradingFormula.detailOrder.totalTypeA({
							contractValue: detailOrder.attributes.metalValueOfTradeIdr,
							fee: detailOrder.attributes.feeIdr,
							tax: detailOrder.attributes.taxIdr,
							direction: detailOrder.attributes.direction,
							currency: "idr",
						})
						const totalTypeAUsd = TradingFormula.detailOrder.totalTypeA({
							contractValue: detailOrder.attributes.metalValueOfTrade,
							fee: detailOrder.attributes.fee,
							tax: detailOrder.attributes.tax,
							direction: detailOrder.attributes.direction,
							currency: "usd",
						})
						this.$set(this.detailOrder, "totalTypeAIdr", totalTypeAIdr)
						this.$set(this.detailOrder, "totalTypeAUsd", totalTypeAUsd)
					}

					// set total
					if (this.$parent.filterStatus != "cancel") {
						const estimatedPriceIdr = TradingFormula.detailOrder.estimatedPrice(
							{
								totalPrice: detailOrder.attributes.paymentIdr,
							},
						)
						const estimatedPriceUsd = TradingFormula.detailOrder.estimatedPrice(
							{
								totalPrice: detailOrder.attributes.paymentUsd,
							},
						)
						this.$set(
							this.detailOrder,
							"estimatedPriceIdr",
							new Decimal(estimatedPriceIdr).toFixed(fractionDigitIdr),
						)
						this.$set(
							this.detailOrder,
							"estimatedPriceUsd",
							new Decimal(estimatedPriceUsd).toFixed(fractionDigitUsd),
						)
					}

					if (this.$parent.filterStatus == "fill") {
						this.$set(
							this.detailOrder,
							"transactionId",
							oneTransaction.responseData.id,
						)

						// set metal value of trade
						const metalValueOfTradeUsd =
							TradingFormula.detailOrder.metalValueOfTrade({
								metalValueOfTradeUsd:
									oneTransaction.responseData.attributes.metalValueOfTrade,
							})
						const metalValueOfTradeIdr =
							TradingFormula.detailOrder.metalValueOfTrade({
								currency: "idr",
								rate: rate,
								metalValueOfTradeUsd:
									oneTransaction.responseData.attributes.metalValueOfTrade,
							})
						this.$set(
							this.detailOrder,
							"metalValueOfTradeUsd",
							metalValueOfTradeUsd,
						)
						this.$set(
							this.detailOrder,
							"metalValueOfTradeIdr",
							metalValueOfTradeIdr,
						)

						// set fxBuffer
						const fxBufferIdr = TradingFormula.detailOrder.fxBuffer({
							metalValueOfTradeIdr: metalValueOfTradeIdr,
						})
						this.$set(this.detailOrder, "fxBufferIdr", fxBufferIdr)

						// set settlement amount
						const settlementAmountUsd =
							TradingFormula.detailOrder.settlementAmount({
								settlementAmountUsd:
									oneTransaction.responseData.attributes.settlementAmount,
							})
						const settlementAmountIdr =
							TradingFormula.detailOrder.settlementAmount({
								currency: "idr",
								rate: rate,
								settlementAmountUsd:
									oneTransaction.responseData.attributes.settlementAmount,
							})
						this.$set(
							this.detailOrder,
							"settlementAmountUsd",
							settlementAmountUsd,
						)
						this.$set(
							this.detailOrder,
							"settlementAmountIdr",
							settlementAmountIdr,
						)
					}

					this.getDetailOrder_Status = "success"
				} catch (error) {
					console.error("ERROR SET DETAIL ORDER", error)
				}
			},

			showEditForm() {
				// uncheck disclaimer
				this.disclaimerCheck = false

				if (this.$store.state.marketStatus == "close") {
					if (this.$store.state.marketCloseType == 2) {
						Swal.fire({
							background: "#191f31",
							title:
								'<span style="color: white;">The market is currently closed</span>',
							html: '<span style="color: white;"> Thanksgiving Holiday Info<br>The market will be closed:<br><br>Friday, Nov 29, 02:30 - 06:00 WIB<br>Saturday, Nov 30, 02:45 - Monday, Des 2, 06:00 WIB<br><br>Normal operations will resume afterward.<br>- JFXGOLD X </span>',
						})
					} else {
						Swal.fire({
							background: "#191f31",
							title:
								'<span style="color: white;">The market is currently closed</span>',
						})
					}
				} else {
					this.limitOrderDate = `${this.validUntil_prop.substr(
						0,
						4,
					)}-${this.validUntil_prop.substr(5, 2)}-${this.validUntil_prop.substr(
						8,
						2,
					)} ${this.validUntil_prop.substr(
						11,
						2,
					)}:${this.validUntil_prop.substr(14, 2)}`
					// this.limitOrderTime = {hour: this.validUntil_prop.substr(11, 5)}

					this.displayFormEdit = "flex"
					this.displayOriginalRowButton = "none"
					this.displayEditRowButton = "block"

					this.displayFormOriginalOpen = "none"
					this.displayFormOriginalFilled = "none"
					this.displayFormOriginalKilled = "none"
				}
			},
			cancelEditForm() {
				// // reset quantity and price per gram
				// this.quantityIntEdit = Math.floor(this.quantity_prop)
				// this.pricePerGramEdit = this.pricePerGram_prop

				this.displayFormEdit = "none"
				this.displayOriginalRowButton = "block"
				this.displayEditRowButton = "none"

				if (this.$parent.filterStatus == "submit") {
					this.displayFormOriginalOpen = "flex"
					this.displayFormOriginalFilled = "none"
					this.displayFormOriginalKilled = "none"
				} else if (this.$parent.filterStatus == "fill") {
					this.displayFormOriginalOpen = "none"
					this.displayFormOriginalFilled = "flex"
					this.displayFormOriginalKilled = "none"
				} else {
					this.displayFormOriginalOpen = "none"
					this.displayFormOriginalFilled = "none"
					this.displayFormOriginalKilled = "flex"
				}

				// this.quantityIntEdit = Math.floor(this.quantity_prop)
				// this.quantityDecimalEdit = 0
			},

			increaseQuantityIntEdit() {
				let temp = Number(this.quantityIntEdit)
				temp += 1

				this.checkQuantityIntEdit(temp)
			},
			decreaseQuantityIntEdit() {
				let temp = Number(this.quantityIntEdit)
				temp -= 1

				this.checkQuantityIntEdit(temp)
			},

			checkQuantityIntEdit(newValue) {
				if (newValue < 0) {
					this.quantityIntEdit = 0
				} else if (
					this.direction == "sell" &&
					new Decimal(newValue).greaterThan(
						Decimal.add(
							this.$store.getters[
								"goldBalanceNew/getAvailableTradeGoldQuantityByContractId"
							](this.contractId_prop),
							this.detailOrder.quantity,
						),
					)
				) {
					this.quantityIntEdit = Decimal.add(
						this.$store.getters[
							"goldBalanceNew/getAvailableTradeGoldQuantityByContractId"
						](this.contractId_prop),
						this.detailOrder.quantity,
					).toNumber()
				} else {
					this.quantityIntEdit = newValue
				}
			},

			increaseQuantityDecimalEdit() {
				let temp = new Decimal(this.quantityDecimalEdit)
				temp = temp.plus(0.1)
				if (temp.greaterThanOrEqualTo(1)) {
					this.quantityDecimalEdit = new Decimal(0.9)
				} else if (temp.lessThan(0)) {
					this.quantityDecimalEdit = new Decimal(0)
				} else {
					this.quantityDecimalEdit = temp
				}
			},
			decreaseQuantityDecimalEdit() {
				let temp = new Decimal(this.quantityDecimalEdit)
				temp = temp.sub(0.1)
				if (temp.greaterThanOrEqualTo(1)) {
					this.quantityDecimalEdit = new Decimal(0.9)
				} else if (temp.lessThan(0)) {
					this.quantityDecimalEdit = new Decimal(0)
				} else {
					this.quantityDecimalEdit = temp
				}
			},

			increasePricePerGramEdit() {
				let temp = new Decimal(this.pricePerGramEdit)
				if (
					this.detailOrder.contractId ==
					this.$store.state.contractIds.contract_001g
				) {
					temp = temp.plus(0.01)
				} else if (
					this.detailOrder.contractId ==
					this.$store.state.contractIds.contract_1g
				) {
					temp = temp.plus(0.01)
				} else {
					temp = temp.plus(0.01)
				}

				if (temp < 0) {
					this.pricePerGramEdit = new Decimal(0)
				} else {
					this.pricePerGramEdit = temp
				}
			},
			decreasePricePerGramEdit() {
				let temp = new Decimal(this.pricePerGramEdit)
				if (
					this.detailOrder.contractId ==
					this.$store.state.contractIds.contract_001g
				) {
					temp = temp.sub(0.01)
				} else if (
					this.detailOrder.contractId ==
					this.$store.state.contractIds.contract_1g
				) {
					temp = temp.sub(0.01)
				} else {
					temp = temp.sub(0.01)
				}

				if (temp.lessThan(0)) {
					this.pricePerGramEdit = new Decimal(0)
				} else {
					this.pricePerGramEdit = temp
				}
			},

			closeModal(status = "") {
				if (status == "afterEdit" || status == "afterDelete") {
					// fetch goldBalance
					this.$store.dispatch("goldBalanceNew/fetchGoldBalance", {
						user_id: this.$store.state.userId,
					})
				}

				this.$parent.firstCall()
				this.closeDetailOrder()
			},

			deleteOrder() {
				let isError = false
				Swal.fire({
					background: "#191f31",
					title:
						'<span style="color: white;">Are you sure you wish to remove this order?</span>',
					html: "<span style='color: white;'>You won't be able to revert this!</span>",
					showCancelButton: true,
					confirmButtonText: "Submit",
					showLoaderOnConfirm: true,
					preConfirm: () => {
						return axios
							.post("/v2/igx/delete_order?order_id=" + this.orderId, {
								user_id: this.$store.state.userId,
							})
							.then((response) => {})
							.catch((error) => {
								isError = true

								return error
							})
					},
					allowOutsideClick: () => !Swal.isLoading(),
				}).then((result) => {
					if (isError) {
						const error = result

						let errorTitle = "Something went wrong."
						let errorText = "Please try again!"
						if (error.data) {
							errorTitle = error.data.err_message
							errorText = ""
						}

						Swal.fire({
							background: "#191f31",
							type: "error",
							title: '<span style="color: white;">' + errorTitle + "</span>",
							html: '<span style="color: white;">' + errorText + "</span>",
						}).then((result) => {
							if (result.value) {
								this.closeModal("afterDelete")
								// location.reload()
							}
						})
					} else if (result.value) {
						Swal.fire({
							background: "#191f31",
							type: "success",
							title: '<span style="color: white;">Deleted!</span>',
							html: '<span style="color: white;">Your order has been deleted.</span>',
						}).then((result) => {
							if (result.value) {
								this.closeModal("afterDelete")
								// location.reload()
							}
						})
					}
				})
			},

			updateOrder() {
				Alert.open({
					type: "loading",
				})

				const fxBufferIdr = Decimal.mul(
					this.fxBufferEditUsd,
					this.streamingRateBuy,
				).toNumber(2)

				axios
					.patch("/v2/igx/edit_order?order_id=" + this.orderId_prop, {
						user_id: this.$store.state.userId,
						quantity: String(
							Decimal.mul(
								this.quantityEdit,
								this.$store.state.contractConfigs[this.detailOrder.contractId]
									.weightCorrection,
							),
						),
						limit_price: Number(
							Decimal.div(
								this.pricePerGramEdit,
								this.$store.state.contractConfigs[this.detailOrder.contractId]
									.weightCorrection,
							).times(
								this.$store.state.contractConfigs[this.detailOrder.contractId]
									.weightMultiplication,
							),
						),
						expired_date: this.expiryDate,
						direction: this.direction,
						fee: this.feeEditUsd,
						tax: this.taxEditUsd,
						fx_buffer_idr: fxBufferIdr,
						payment_idr: this.totalIdrLimitEdit,
						payment_usd: this.totalUsdLimitEdit,
						est_pnl_idr: this.pnlIdrEdit,
						est_pnl_usd: this.pnlUsdEdit,
						unrealized_pnl_idr: this.estimasiProfitEditIdr,
						unrealized_pnl_usd: this.estimasiProfitEditUsd,
					})
					.then(() => {
						// this.$refs.alertRef.changeType('success')
						// this.$refs.alertRef.changeText('Your order has been updated')
						// this.$refs.alertRef.changeButtonYesText('Close')
						// this.$refs.alertRef.changeNext('backToReports')
						// this.$refs.alertRef.openModal()

						Alert.open({
							type: "success",
							title: "Edit Order Sukses",
							description: " ",
							buttonCloseText: "Ok",
							showBanner: this.direction == "buy",
							bannerStyle: "info",
							bannerMessage:
								"Instant RoG akan masuk ke saldo RPED ketika transaksi filled/partial filled. Informasi cashback akan dikirim via email",
							onClose: () => {
								this.cancelEditForm()
								this.closeModal("afterEdit")
							},
						})
					})
					.catch(() => {
						// this.$refs.alertRef.changeType('error')
						// this.$refs.alertRef.changeText('Failed')
						// this.$refs.alertRef.changeButtonYesText('Close')
						// this.$refs.alertRef.changeNext('backToReports')
						// this.$refs.alertRef.openModal()

						Alert.open({
							type: "error",
							title: "Edit Order Gagal",
							buttonCloseText: "Close",
						})
					})
			},

			// closeAlert(payload) {
			// 	if (payload.payload.status == 'yes' && payload.next == 'submit') {
			// 		this.$refs.alertRef.changeType('loading')
			// 		this.$refs.alertRef.openModal()

			// 		this.updateOrder()
			// 	}

			// 	else if (payload.payload.status == 'success' && payload.next == 'backToReports') {
			// 		document.getElementById("buttonCloseEditOrder").click()
			// 		this.closeModal('afterEdit')

			// 		// location.reload()
			// 	}

			// 	this.disclaimerCheck = false
			// },
			confirmSubmit() {
				// LOG for QA =========================================
				const holding = this.$store.getters.getHoldingByContractId(
					this.detailOrder.contractId,
				)
				const contractConfig = this.$store.getters.getContractConfigs(
					this.detailOrder.contractId,
				)

				console.log(
					"==================== EDIT ORDER ====================",
					contractConfig,
				)

				const contractPrice = Decimal.div(
					this.pricePerGramEdit,
					contractConfig.weightCorrection,
				).toFixed(4)
				const quantity = Decimal.mul(
					this.quantityEdit,
					contractConfig.weightCorrection,
				).toFixed(4)

				console.log("⭐⭐⭐⭐⭐⭐⭐⭐")
				console.log("Contract: " + contractConfig.name)
				console.log("Contract ID: " + this.detailOrder.contractId)
				console.log("Direction: " + this.direction)
				console.log("Order Type: LIMIT")
				console.log("Rate SELL: " + this.streamingRateSell)
				console.log("Contract Price SELL USD: " + contractPrice)
				console.log(
					"Contract Value USD: " +
						Decimal.mul(contractPrice, quantity).toFixed(4),
				)
				console.log("Quantity Order: " + this.quantityEdit)
				console.log(
					"Gram Order: " +
						Decimal.mul(quantity, contractConfig.weightInGram)
							.div(contractConfig.weightCorrection)
							.toFixed(4),
				)

				if (holding) {
					console.log("Quantity Holding: " + holding.quantity)
					console.log(
						"Gram Holding: " +
							Decimal.mul(
								holding.quantity,
								contractConfig.weightInGram,
							).toFixed(4),
					)
				} else {
					console.log("Holding Quantity: 0")
					console.log("Holding Gram: 0")
				}

				console.log("Average Total Cost USD: " + holding.avg_total_cost)
				console.log("Average Total Cost IDR: " + holding.avg_total_cost_idr)

				console.log("PNL AKHIR USD: " + this.pnlUsdEdit)
				console.log("PNL AKHIR IDR: " + this.pnlIdrEdit)
				// ====================================================================

				if (
					this.priceOzt15PercentAway &&
					this.$store.getters.getContractConfigs(this.detailOrder.contractId)
						.contractType == "kau"
				) {
					Swal.fire({
						background: "#191f31",
						html:
							'<span style="color: white;">The price of this order is ' +
							this.numberFormatExtend(
								Decimal.mul(this.minMaxLimitPrice, 100).toFixed(2),
							) +
							"% away from current market price.</span>",
					})

					return
				}

				if (new Decimal(this.totalUsdLimitEdit).lessThanOrEqualTo(0)) {
					Swal.fire({
						background: "#191f31",
						html: '<span style="color: white;">Order total must be greater than zero.</span>',
					})

					return
				}

				// check if quantity edit more than available quantity that can be SELL
				if (
					this.direction == "sell" &&
					new Decimal(this.quantityEdit).greaterThan(
						Decimal.add(
							this.$store.getters[
								"goldBalanceNew/getAvailableTradeGoldQuantityByContractId"
							](this.contractId_prop),
							this.detailOrder.quantity,
						),
					)
				) {
					Swal.fire({
						background: "#191f31",
						html:
							"<span style='color: white;'>You don't have enough " +
							this.$store.getters.getContractConfigs(
								this.detailOrder.contractId,
							).name +
							" gold.</span>",
					})

					return
				}

				// check available trade balance
				if (
					new Decimal(this.$store.state.availableTradeBalanceIdr).lessThan(
						this.totalIdrLimitEdit,
					) &&
					this.direction == "buy"
				) {
					Swal.fire({
						background: "#191f31",
						html: "<span style='color: white;'>You don't have enough available trade balance.</span>",
					})

					return
				}

				// this.$refs.alertRef.changeType('confirmation')
				// this.$refs.alertRef.changeText('Are you sure want to edit this order?')
				// this.$refs.alertRef.changeButtonNoText('NO')
				// this.$refs.alertRef.changeButtonYesText('YES')
				// this.$refs.alertRef.changeNext('submit')
				// this.$refs.alertRef.openModal()

				Alert.open({
					type: "confirm",
					iconColor: "warning",
					title: "Apakah Anda Yakin ingin Melakukan Edit Order?",
					description: "",
					buttonConfirmText: "Ya, Lanjutkan",
					buttonDeclineText: "Batal",
					showBanner: true,
					bannerStyle: "warning",
					bannerMessage:
						"Edit order dapat membatalkan limit order Anda sebelumnya dan akan membuat order baru",
					onConfirm: () => {
						this.updateOrder()
					},
				})
			},
		},
	}
</script>

<style scoped>
	.detail-order {
		width: 25.75rem;
		max-width: calc(100% - 2.5rem);
	}

	.modalDialog {
		position: fixed;
		font-family: Arial, Helvetica, sans-serif;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		overflow-y: scroll;
		background: rgba(0, 0, 0, 0.8);
		z-index: 1050;
		opacity: 0;
		-webkit-transition: opacity 400ms ease-in;
		-moz-transition: opacity 400ms ease-in;
		transition: opacity 400ms ease-in;
		pointer-events: none;
	}

	.modalDialog:target {
		opacity: 1;
		pointer-events: auto;
	}

	.modal-open {
		opacity: 1;
		pointer-events: auto;
	}

	.modalDialog > div {
		max-width: 400px;
		position: relative;
		margin: 2% auto;
		padding: 1.5em;
		border-radius: 5px;
		background: #25273a;
		background: -moz-linear-gradient(#fff, #999);
		background: -webkit-linear-gradient(#fff, #999);
		background: -o-linear-gradient(#fff, #999);
		color: rgba(255, 255, 255, 0.5);
	}

	.close {
		background: #606061;
		color: #ffffff;
		line-height: 25px;
		position: absolute;
		right: -12px;
		text-align: center;
		top: -10px;
		width: 24px;
		text-decoration: none;
		font-weight: bold;
		-webkit-border-radius: 12px;
		-moz-border-radius: 12px;
		border-radius: 12px;
		-moz-box-shadow: 1px 1px 3px #000;
		-webkit-box-shadow: 1px 1px 3px #000;
		box-shadow: 1px 1px 3px #000;
	}

	.close:hover {
		background: #00d9ff;
	}

	.c-prepend-button:hover {
		cursor: pointer;
	}

	.c-append-button:hover {
		cursor: pointer;
	}

	.form-control-plaintext {
		padding: 0px 1px 2.5px 1px;
	}

	input {
		text-transform: uppercase;
	}

	.c-select {
		padding-top: 1px;
		padding-bottom: 0px;
		padding-left: 5px;
		font-size: 12px;
	}

	input.c-disabled {
		color: rgb(255, 255, 255, 0.8);
	}

	.c-input {
		margin: 0 2px;
		padding: 0 8px;
		border: 2px solid #171721;
		background: transparent;
		height: 26.4px;
		border-radius: 4px;
		text-align: center;
		width: 93px;
		min-width: 80px;
	}

	.c-input:focus {
		border-color: gold;
		outline: none;
	}

	.button-counter {
		margin: 0;
		/*padding: 0;*/
		border: 0;
		height: 26.4px;
		width: 26.4px;
		background-color: #171721;
		color: gold;
		font-weight: bold;
		border-radius: 4px;
	}

	.button-counter:hover {
		cursor: pointer;
	}

	.button-counter:active {
		background-color: gold;
		color: #25273a;
	}

	.button-counter:focus {
		outline: 0;
	}

	.value-field {
		background-color: transparent;
		padding: 0;
	}

	.total-value {
		color: gold;
		font-size: 16px;
	}

	.total-value.total-value-idr {
		line-height: 16px;
	}

	.c-input.c-date-picker {
		position: relative;
		padding-left: 7px;
		padding-right: 6.5px;
		margin: 0;
		width: 180px;
		font-size: 12px;
		outline: 0;
		text-align: left;
		border: 0;
		background-color: #171721;
		cursor: text;
		color: white;
	}

	input[type="date"]::-webkit-calendar-picker-indicator {
		position: relative;
		margin-left: 0;
		right: -3.5px;
		color: transparent;
		background: none;
		z-index: 1;
		outline: 0;
		cursor: pointer;
	}

	input[type="date"]:before {
		color: white;
		background: none;
		display: block;
		content: "\0023CD";
		position: absolute;
		top: 0px;
		right: 7px;
		color: gold;
	}

	.title-alert {
		font-size: 1.375rem;
		font-weight: 500;
		margin-bottom: 0.75rem;
	}

	.text-alert {
		margin-bottom: 2rem;
	}

	input[type="checkbox"] {
		-webkit-appearance: checkbox;
	}
</style>
